import { useState, useEffect } from "react";

/**
 * Subscribe to a CSS media query and re-render when it changes.
 * SSR-safe and cleans up its own listener.
 *
 *   const isMobile = useMediaQuery("(max-width: 860px)");
 */
export function useMediaQuery(query) {
  const getMatch = () =>
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    // Sync immediately in case the query changed between render and effect.
    setMatches(mql.matches);
    mql.addEventListener?.("change", handler);
    return () => mql.removeEventListener?.("change", handler);
  }, [query]);

  return matches;
}

/** Convenience breakpoint hooks used across the app shell. */
export const useIsMobile = () => useMediaQuery("(max-width: 860px)");
export const useIsTablet = () =>
  useMediaQuery("(min-width: 861px) and (max-width: 1180px)");

export default useMediaQuery;
